import * as React from 'react';
import { FC } from 'react';
import { IIconProps } from '../types';
import { SIMPLIFY_COLORS } from '../../../constants/colors';

export const IconSuccess: FC<IIconProps> = props => {
  const { color: _color } = props;

  const color = _color ? SIMPLIFY_COLORS[_color] : 'white';

  return (
    // oxlint-disable-next-line react/forbid-elements
    <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.2 2.3001L4.4 7.1001C4 7.5001 3.4 7.5001 3 7.1001L0.8 4.9001C0.4 4.5001 0.4 3.9001 0.8 3.5001C1.2 3.1001 1.8 3.1001 2.2 3.5001L3.7 5.0001L7.8 0.900098C8.2 0.500098 8.8 0.500098 9.2 0.900098C9.6 1.3001 9.6 1.9001 9.2 2.3001Z"
        fill={color}
      />
    </svg>
  );
};
